import { createAction } from '@reduxjs/toolkit';

import type { ShareTextValueEntry } from 'features/share-text/interfaces';

export const shareTextEntryAppended = createAction<ShareTextValueEntry>(
  'shareText/entryAppended'
);

export const shareTextChatChunkApplied = createAction<string>(
  'shareText/chatChunkApplied'
);

export const shareTextDialpadCleared = createAction('shareText/dialpadCleared');

export const shareTextAllCleared = createAction('shareText/allCleared');
